const PS_CARE_PLUS_ASSET_BASE =
  "https://storage.googleapis.com/ps-asset/affiliate/logo/PSCAREBUNDLE";

/**
 * PolicyStreet Care+ bundle, shown on the comparison page whenever the
 * quotation's add-on list contains a `PSCAREPLUS` row.
 *
 * Same split as INSURER_CAR_PLUS_PACKAGE: the DB add-on row carries
 * availability and price, this constant carries the copy. The difference is
 * scope - MyCar Plus is an insurer product and is therefore keyed by insurer
 * name, while Care+ is a partner product, so there is one package and no key.
 * That also means the selection must survive an insurer switch; see
 * initPolicyStreetCarePlus() in comparison.component.ts.
 */
export const POLICYSTREET_CARE_PLUS_PACKAGE = {
  settings: {
    showCheckbox: true,

    /**
     * The card design carries no price - RM 100 appears in the order summary
     * only, which is rendered separately from this block.
     */
    showPrice: false,

    /**
     * ToW makes Care+ mandatory (ticked, greyed out, not tappable); Renewal
     * leaves it optional but ticked by default.
     *
     * The comparison flow cannot tell the two apart yet - GetRequestInfoById
     * returns no renewal or ownership-transfer field - so both journeys get the
     * Renewal behaviour for now. Once that flag exists this becomes the only
     * thing to derive; the template already binds the checkbox to it.
     */
    isMandatory: false
  },

  code: "PSCAREPLUS",
  banner: {
    en: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_Carsome_Banner-en.png`,
    bm: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_Carsome_Banner-bm.png`
  },
  logo: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_PSLogo.png`,
  title: "addOn.PSCarePlus_Title",
  description: "addOn.PSCarePlus_Desc",

  /**
   * Rendered as a two-column grid in card order (left column first), so the
   * sequence here is the sequence on screen.
   */
  benefits: [
    {
      image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_PALogo.png`,
      title: "addOn.PSCarePlus_PersonalAccident_Title",
      description: "addOn.PSCarePlus_PersonalAccident_Desc"
    },
    {
      image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_HospLogo.png`,
      title: "addOn.PSCarePlus_HospitalizationIncome_Title",
      description: "addOn.PSCarePlus_HospitalizationIncome_Desc"
    },
    {
      image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_RPLogo.png`,
      title: "addOn.PSCarePlus_RetrenchmentProtection_Title",
      description: "addOn.PSCarePlus_RetrenchmentProtection_Desc"
    },
    {
      image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_ClaimLogo.png`,
      title: "addOn.PSCarePlus_DedicatedClaimsSupport_Title",
      description: "addOn.PSCarePlus_DedicatedClaimsSupport_Desc"
    },
    {
      image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_BRDLogo.png`,
      title: "addOn.PSCarePlus_BatteryReplacementDiscount_Title",
      description: "addOn.PSCarePlus_BatteryReplacementDiscount_Desc"
    },
    {
      image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_CMDLogo.png`,
      title: "addOn.PSCarePlus_CarMaintenanceDiscount_Title",
      description: "addOn.PSCarePlus_CarMaintenanceDiscount_Desc"
    }
  ]
};
